<div class="background-image" id="dashboard">

  <div class="container">

    <div class="body">
      <app-header></app-header>

      <div class="contact">
        <app-contact-swiper></app-contact-swiper>
      </div>

      <div class="title" style="flex-direction: row !important;">
        <img style="max-height: 60px; margin-right: 20px;" src="/assets/logos/logo_3_cropped.png">
        <div class="name">
          <h1>MARCUS COUBE</h1>
          <p>SOFTWARE ENGINEER</p>
        </div>
      </div>

      <div class="about">
        <app-curriculum-swiper></app-curriculum-swiper>
      </div>

    </div>

<!--    <div class="down-arrow">-->
<!--      <span class="iconify" data-icon="akar-icons:arrow-down"></span>-->
<!--    </div>-->
    <app-down-arrow></app-down-arrow>
  </div>

</div>
